import { API } from "apis";
import CandidateCorpListItem from "components/candidate-corp/CandidateCorpListItem";
import PageTitle from "components/common/PageTitle";
import ContactDialog from "components/dialog/ContactDialog";
import { CandidateCorpModel, ContextModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useOutletContext } from "react-router-dom";
import { Utils } from "utils";

/** 「商談候補会社」画面 */
const CandidateCorpPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [data, setData] = React.useState<CandidateCorpModel[]>([]);
  const [selectedList, setSelectedList] = React.useState<CandidateCorpModel[]>(
    []
  );
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const onChangeSelectedState = (item: CandidateCorpModel, value: boolean) => {
    const idx = selectedList.indexOf(item);
    if (idx >= 0) {
      if (value === false) {
        selectedList.splice(idx, 1);
        setSelectedList(selectedList.concat());
      }
    } else {
      if (value === true) {
        const tmp = [];
        for (const i of data) {
          if (selectedList.includes(i)) {
            tmp.push(i);
          } else if (i === item) {
            tmp.push(i);
          }
        }
        setSelectedList(tmp);
      }
    }
  };

  const onDelete = async (item: CandidateCorpModel) => {
    ctx.loading.setState(true);
    try {
      const response = await API.CandidateCorp.del(item.corp_id);
      console.log(response);
      if (response.data.success) {
        // 再ロード
        const response = await API.CandidateCorp.list();
        console.log(response);
        setData(response.data);

        let tmp = selectedList.map((selected) => {
          return response.data.find((v) => v.corp_id === selected.corp_id);
        });
        tmp = tmp.filter((v) => v !== undefined);
        setSelectedList(tmp as CandidateCorpModel[]);
      }
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  const onCloseContactDialog = async (result: boolean) => {
    setIsOpen(false);

    if (!result) {
      return;
    }
    setSelectedList([]);
    // 商談候補会社のリロード
    ctx.loading.setState(true);
    try {
      const response = await API.CandidateCorp.list();
      console.log(response);
      setData(response.data);
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(true);
      await ctx.auth.initialize();

      try {
        const response = await API.CandidateCorp.list();
        console.log(response);
        setData(response.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (data.length === 0) {
    return (
      <div className="">
        <Helmet>
          <title>商談候補会社</title>
        </Helmet>
        <PageTitle title="商談候補会社" className="p-2" />
        <div className="flex justify-center py-12">
          <div>商談候補会社がありません。</div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <Helmet>
        <title>商談候補会社</title>
      </Helmet>
      <PageTitle title="商談候補会社" className="p-2" />
      <div className="p-4 flex flex-col gap-4">
        {data.map((item, index) => (
          <CandidateCorpListItem
            key={index}
            item={item}
            selectedList={selectedList}
            onChangeSelectedState={onChangeSelectedState}
            onDelete={onDelete}
          />
        ))}
      </div>
      <div className="m-4 text-center p-8 bg-blue-200">
        <div>チェックした会社に</div>
        <div className="mt-4">
          <button
            className={`${selectedList.length === 0 ? 'secondary-disabled px-4 py-2 ' : 'secondary px-4 py-2 '}`}
            onClick={() => setIsOpen(true)}
            disabled={selectedList.length === 0}
          >
            まとめてお問い合わせ
          </button>
        </div>
      </div>

      <ContactDialog
        ctx={ctx}
        modalIsOpen={modalIsOpen}
        close={onCloseContactDialog}
        targets={selectedList}
      />
    </div>
  );
};
export default CandidateCorpPage;
